import React, { memo, useEffect } from "react";
import { Navigate } from "react-router";
import metadataJSON from "@/utils/metadata.json";
import { StringCaser } from "@/utils/utils";
import { useContexts } from "@/hooks/useContexts";

interface CustomerRouteProps {
  path: string;
  children: React.ReactNode;
}

const CustomerRoutes: React.FC<CustomerRouteProps> = ({ path, children }) => {
  const { authState } = useContexts();
  const stringCaser = new StringCaser();

  const { isAuthenticated } = authState;

  useEffect(() => {
    const metadata = metadataJSON[path ?? "/"];
    if (metadata !== undefined) {
      document.title = metadata?.title
        ? stringCaser.Capitalize(metadata?.title, {
            separator: " ",
          })
        : "Content Gap";
    } else {
      document.title = "Content Gap";
    }
  }, [path]);

  return (
    <>
      {isAuthenticated ? (
        <>{children}</>
      ) : (
        <Navigate to="/customer/login" replace />
      )}
    </>
  );
};

export default memo(CustomerRoutes);
